import { SPACE_CHANGED } from "./constants"

export const emitSpaceChanged = (pid,newSpace,oldSpace) => {
    window.dispatchEvent(new CustomEvent(SPACE_CHANGED,{detail:{
        pid:pid,
        newSpace:newSpace,
        oldSpace:oldSpace
    }}))
}
